import { Alert } from "@mui/material"
import { ActivityOpen } from "event-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ErrorButton } from "lib/@components/colored-buttons/error-button"
import { If } from "lib/@components/switch"
import { PublishingStepsBelow } from "slot-definitions"
import { hasRegimeRejectedAudits } from "./controller/has-regime-rejected-audits"
import { Feature } from "lib/@components/feature"
import { FEATURE_FLAG_REGIME_AUDITING } from "routes/regime/plugins/regime-auditing/server/feature-flag-regime-auditing.mjs"

PublishingStepsBelow.plug(
    <If field="activeStep.props.id" equals="Draft">
        <Feature feature={FEATURE_FLAG_REGIME_AUDITING}>
            <RejectionSummaryBanner />
        </Feature>
    </If>
)

export function RejectionSummaryBanner() {
    const { parentItem, activeStep } = useBoundContext()

    const isAvailable = activeStep.props.available()
    const version = typeof isAvailable === "number" && !Number.isNaN(isAvailable) ? isAvailable : 0

    const hasBeenRejected = hasRegimeRejectedAudits.useResults(parentItem?.id, "maintenanceRegime", version) ?? false

    return (
        !!hasBeenRejected && (
            <Alert
                severity="error"
                sx={{ my: 1 }}
                data-cy="rejection-summary-alert"
                action={
                    <ErrorButton
                        size="small"
                        sx={{ marginRight: 1 }}
                        text="Activity Log"
                        onClick={handleClick}
                        data-cy="rejection-summary-activity-button"
                    />
                }
            >
                This draft contains changes returned from review. See rejection notes.
            </Alert>
        )
    )

    function handleClick() {
        ActivityOpen.raise()
    }
}
